import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from './AuthContext';

export const RequireRole: React.FC<{ roles: string[]; children: React.ReactElement }> = ({ roles, children }) => {
  const { auth } = useAuth();
  if (!auth.user) return <Navigate to="/" replace />; // not logged in
  // Exact uppercase role match (roles are 'ADMIN' or 'SHOP_OWNER')
  const roleNormalized = String(auth.role || '').toUpperCase();
  const allowed = roles.map(r => String(r).toUpperCase());
  if (allowed.includes(roleNormalized)) return children;
  // fallback: admin implied
  if (auth.user?.isAdmin) return children;
  return <Navigate to="/landing" replace />;
};

export const RequireShopOwner: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { auth, ownsShop } = useAuth();
  const params = useParams();
  const shopId = params.shopId as string | undefined;

  if (!auth.user) return <Navigate to="/" replace />; // not logged in
  if (!shopId) return <Navigate to="/landing" replace />;
  if (ownsShop(shopId)) return children;
  // allow admins
  if (auth.user?.isAdmin) return children;
  return <Navigate to="/landing" replace />;
};

export default {} as any;
